import {EMPTY_OBJECT} from '../consts/commonConsts';

import {getLocalizationService} from './localisationService';

export class ApiError extends Error {
  status: number;

  url: string;

  data?: any;

  errors?: unknown[];

  error?: Record<string, unknown>;

  constructor({
    status,
    message,
    url,
    originalStack,
    data,
    errors,
    error,
  }: {
    status: number;
    message: string;
    url: string;
    originalStack?: string;
    data?: any;
    errors?: unknown[];
    error?: Record<string, unknown>;
  }) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.url = url;
    this.data = data;
    this.errors = errors;
    this.error = error;
    if (originalStack) {
      this.stack = `${this.stack}\nCaused by: ${originalStack}`;
    }
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export const createAndThrowApiError = (error: Record<string, any>): never => {
  const {t} = getLocalizationService();

  if (error?.response) {
    const {status, config, data} = error?.response || EMPTY_OBJECT;
    throw new ApiError({
      status,
      originalStack: error?.stack,
      message: data?.description || error?.toJSON()?.message || 'http request failed',
      url: config?.url,
    });
  }

  const {data, config} = error || EMPTY_OBJECT;
  const errorData = data?.errors?.[0];
  throw new ApiError({
    message: errorData?.errorDesc || t('something_went_wrong_try_again_later'),
    url: config?.url,
    status: errorData?.errorCode,
    originalStack: errorData?.stack,
    data: data?.data,
    errors: data?.errors,
    error,
  });
};

export const isApiError = (err: unknown): err is ApiError => err instanceof ApiError;

export const is401Error = (e: unknown) =>
  (isApiError(e) ? e?.status === 401 : typeof e === 'string' && e.includes('401'));
